/*
dilip 01/04/2023 2699714747 Added Map Record Group Step
dilip 01/06/2023 2699714747 Added Map Record Group Changes and Integrated Save and Get API.
Sohel 01/09/2023 2699714747 changed stepper redirect condition
dilip 01/10/2023 2699714747 Added unsaved popup.
dilip 01/11/2023 2699714747 Removed Customer Query Button.
Dilip 01/12/2023 2699714747 changed tooltip for sav and next button
dilip 01/12/2023 2699714747 Added Map Exception Records Step changes.
dilip 01/12/2023 2699714747 Fixed message and status reset issue.
dilip 01/13/2023 2699714747 Fixed Data Export records mapping issue for Customer Query.
dilip 01/13/2023 2699714747 Fixed Parent Record setting issue for Export Manager Record.
dilip 01/13/2023 2699714747 Fixed button disable issue.
 dilip 01/16/2023 2699714747 Added GET data API call after map records save.
 dilip 01/16/2023 2699714747 Added save button disable condition for Customer Query Type.
 dilip 01/16/2023 2699714747 Added Master Record payload for search records.
 dilip 01/17/2023 2699714747 Fixed saving as completed.
 dilip 01/20/2023 2699714747 Added Map Exception functionality for IM Record Group
 dilip 01/20/2023 2699714747 Added Last Step functionality
 Ashraf 01/27/2023 2699714747 added new fields props
Ashraf 01/31/2023 2699714747 Added multirecord in payload
Ravi 01/31/2023 2699714747 fixed unsaved popup issue
suresh peddavoora 02/22/2023 2699714747 New UI changes implemented
Sohel 02/03/2023 2699714747 Header Footer Conditions
//Sohel 02/03/2023 2698964415 hide Footer And header button
Ravi 03/08/2023 2699714747 Added Import and Import Template in Data Repository title
Sohel 03/13/2023 2699714747 Fixed Save button Disabled issue
Sohel 02/14/2023 2698964415 show header and footer button
Ravi 02/17/2023 2698964415 fixed status issue
Akhila 06/12/2023 2698964415 added role access
Sohel 06/10/2023 2698964415 Fixed Label Issue
Sohel 06/19/2023 3075154998 Enable Save Button
Ravi 06/19/2023 2698964415 Added Breadcrum in popup
Ravi 06/23/2023 2698964415 fixed submit issue
*/
import React, {useState, useEffect, useRef} from 'react';
import {Button, Tooltip} from '@material-ui/core';
import {useSelector, useDispatch} from 'react-redux';
import reusableInputStyles from '../../../../../components/InputStyles';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import PageLoader from '../../../../../components/PageLoader';
import {
  postMapRecordInfo,
  getRecordMapData,
  setParentRecordException,
  resetMsgAndStatus,
} from '../../../../../redux/reducers/DataManager';
import SearchRecords from '../../../DataManager/DataManagerRecord/SearchDataManagerRecord';
import SearchImportMRGroup from '../../../DataManager/ImportManagerRecordGroup/SearchImportMRGroup/index.js';
import DialogBox from './../../../../../components/DialogBox/index';
import MappedRecordsTable from './MappedRecordTable';
import BreadCrums from '../../../../../util/BreadCrum';
import AddIcon from '@material-ui/icons/Add';
import {Form, Formik} from 'formik';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';

const MapRecordGroup = ({
  labelChanges,
  handleBack,
  exportManager,
  handleDirty,
  handleNext,
  setValue,
  hidden,
  editExisting,
  DataManagerAccess,
}) => {
  const classes = reusableInputStyles();
  const [open, setOpen] = useState(false);
  const saveRef = useRef();
  const recordTypeRef = useRef('');
  const masterRecordRef = useRef('');
  const [tempSelectedRows, setTempSelectedRows] = useState([]);
  const [records, setRecords] = useState([]);
  const dispatch = useDispatch();
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const initialValues = {
    recordsLength: 0,
  };
  const type = exportManager ? 'Export' : 'Import';
  const {
    isBasicInfoLoading,
    basicInfoErrorMsg,
    basicInfoSuccessMsg,
    basicInfoData,
    recordsData,
    mappedRecordsStatus,
  } = useSelector(({dataManagerGroup}) => dataManagerGroup);
  useEffect(() => {
    if (basicInfoData?.dmCode) {
      dispatch(getRecordMapData(basicInfoData?.dataManagerId));
    }
  }, [basicInfoData]);

  useEffect(() => {
    if (basicInfoData?.dmCode && mappedRecordsStatus === 200 && saveRef.current) {
      dispatch(getRecordMapData(basicInfoData?.dataManagerId));
    }
  }, [mappedRecordsStatus]);

  const isMultiRecordFormat =
    basicInfoData?.multiRecordFormat === 'Yes' || basicInfoData?.multiRecordFormat === 'Y';
  useEffect(() => {
    if (recordsData?.length > 0) {
      const data = recordsData?.length > 0 ? recordsData?.map(el =>{
        return {
          ...el,
          dataManagerRecordId:!isMultiRecordFormat && el?.recordId ?  el?.recordId :0,
          dmRecordGroupId:isMultiRecordFormat && el?.recordId ? el?.recordId:0, 
        }
      }):[];
      setRecords(data);
    }
  }, [recordsData]);
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);
  useEffect(() => {
    if (basicInfoErrorMsg || basicInfoSuccessMsg) {
      setTimeout(() => {
        if (mappedRecordsStatus === 200 && basicInfoSuccessMsg && !saveRef.current) {
          handleNext();
        }
        dispatch(resetMsgAndStatus());
      }, 1500);
    }
  }, [basicInfoErrorMsg, basicInfoSuccessMsg]);

  useEffect(() => dispatch(resetMsgAndStatus()), []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (values) => {
    const obj = {};
    const obj2 = {};
    if (recordsData?.length > 0) {
      recordsData?.forEach((row) => {
        obj[row?.recordCode] = row?.recordMapId;
        obj2[row?.recordCode] = row?.recordMapId;
      });
    }
    if (records?.length > 0) {
      records?.forEach((row2) => {
        if (obj[row2?.recordCode]) {
          delete obj[row2?.recordCode];
        }
      });
    }
    if (basicInfoData?.dmCode) {
      dispatch(submissionStart());
      const recordsArr = records.map((el) => {
        const existingIds = obj2[el.recordCode] ? obj2[el.recordCode] : null;
        if (el.recordType === basicInfoData?.dmType && !exportManager) {
          if (isMultiRecordFormat) {
            dispatch(setParentRecordException(el.masterRecord));
          } else {
            dispatch(setParentRecordException(el.recordCode));
          }
        }
        return {
          recordCode: el.recordCode,
          recordDescription: el.recordDescription,
          recordMapId: el?.recordMapId ? el?.recordMapId : existingIds ? existingIds : 0,
          recordType: el.recordType,
          masterRecord: el?.masterRecord || '',
          recordId: !isMultiRecordFormat && el?.dataManagerRecordId ? el?.dataManagerRecordId : isMultiRecordFormat && el?.dmRecordGroupId ? el?.dmRecordGroupId: 0,
        };
      });
      const payload = {
        dataManagerId: basicInfoData?.dataManagerId ? basicInfoData?.dataManagerId : 0,
        fileType: exportManager ? 'Export' : 'Import',
        recordMapRequests: recordsArr,
        dmCode: basicInfoData?.dmCode,
        mapType: isMultiRecordFormat ? 'Record Groups' : '',
        deleteIds: Object.values(obj).length > 0 ? Object.values(obj) : [],
        isDraft:
          basicInfoData?.isDraft && !exportManager ?
            basicInfoData?.isDraft :
            exportManager ?
              'N' :
              'Y',
        
        lastStep: saveRef.current ? 1 : 2,
        multiRecord: exportManager && basicInfoData?.multiRecordFormat,
      };
      dispatch(postMapRecordInfo(payload));
    }
  };

  const disableFunction = (type) => records.filter((item) => item.recordType === type)?.length >= 1;
  return (
    <>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={handleSubmit}
        validateOnChange
      >
        {(props) => {
          const {values} = props;
          return (
            <Form noValidate>
              <div className="d-flex col-12 new-standard-textfields">
                <div>
                  <BreadCrums
                    name={exportManager ? 'Export Manager Name' : 'Import Manager Name'}
                    code={basicInfoData?.dmCode}
                    description={
                      exportManager ? 'Export Manager Description' : 'Import Manager Description'
                    }
                    descriptionValue={basicInfoData?.dmDescription}
                    returnType={'Type'}
                    returnTypeValue={basicInfoData?.dmType || ''}
                  />
                </div>
              </div>
              <div className="table-header table-card-header justify-content-end new-standard-textfields">
                {(isMultiRecordFormat || exportManager) && (
                  <Button
                    variant="outlined"
                    className={`search-btn ${classes.buttonRoot} mr-2`}
                    onClick={() => {
                      recordTypeRef.current = 'Header';
                      masterRecordRef.current = '';
                      setOpen(true);
                    }}
                    disabled={disableFunction('Header')}
                    startIcon={<AddIcon />}
                  >
                    {!isMultiRecordFormat ? 'Header' : 'Header Group'}
                  </Button>
                )}
                {(isMultiRecordFormat || exportManager) && (
                  <Button
                    variant="outlined"
                    className={`search-btn ${classes.buttonRoot} mr-2`}
                    disabled={disableFunction('Footer')}
                    onClick={() => {
                      recordTypeRef.current = 'Footer';
                      masterRecordRef.current = '';
                      setOpen(true);
                    }}
                    startIcon={<AddIcon />}
                  >
                    {!isMultiRecordFormat ? 'Footer' : 'Footer Group'}
                  </Button>
                )}
                {basicInfoData?.dmType && !exportManager ? (
                  <Button
                    variant="outlined"
                    className={`search-btn ${classes.buttonRoot} mr-2`}
                    disabled={disableFunction(basicInfoData?.dmType)}
                    onClick={() => {
                      recordTypeRef.current = basicInfoData?.dmType;
                      basicInfoData?.dmType === 'Customer Query' ?
                        (masterRecordRef.current = '') :
                        (masterRecordRef.current = 'Y');
                      setOpen(true);
                    }}
                    startIcon={<AddIcon />}
                  >
                    {!isMultiRecordFormat ?
                      `${basicInfoData?.dmType || ''}` :
                      `${basicInfoData?.dmType || ''} Group`}
                  </Button>
                ) : null}
                {['Data Export', 'Customer Query'].includes(basicInfoData?.dmType) ? (
                  <Button
                    variant="outlined"
                    className={`search-btn ${classes.buttonRoot}`}
                    onClick={() => {
                      recordTypeRef.current = 'Data Export';
                      masterRecordRef.current = '';
                      setOpen(true);
                    }}
                    startIcon={<AddIcon />}
                  >
                    Data Export
                  </Button>
                ) : null}
              </div>
              <MappedRecordsTable
                setRecords={setRecords}
                records={records}
                isMultiRecordFormat={isMultiRecordFormat}
                handleDirty={handleDirty}
                editExisting={editExisting}
                DataManagerAccess={DataManagerAccess}
              />

              <DialogBox
                open={open}
                dialogClose={handleClose}
                // title={
                //   !isMultiRecordFormat
                //     ? `Search ${type} Template Records`
                //     : `Search ${type} Record Groups`
                // }
                title={
                  <div className="dialog-breadcrum">
                    <p className="dialoge-title-breadcrum">
                      <b> {!isMultiRecordFormat ?
                    `Search ${type} Template Records` :
                    `Search ${type} Record Groups`}</b>
                    </p>
                    <BreadCrums
                      name={exportManager ? 'Export Manager Name' : 'Import Manager Name'}
                      code={basicInfoData?.dmCode}
                      description={
                        exportManager ? 'Export Manager Description' : 'Import Manager Description'
                      }
                      descriptionValue={basicInfoData?.dmDescription}
                    />
                  </div>
                }
                maxWidth="xl"
              >
                {!isMultiRecordFormat ? (
                  <SearchRecords
                    setRecords={setRecords}
                    records={records}
                    setTempSelectedRows={setTempSelectedRows}
                    tempSelectedRows={tempSelectedRows}
                    handleClose={handleClose}
                    recordGroupType={{value: recordTypeRef.current}}
                    exportManagerRecordGroup={
                      exportManager || recordTypeRef.current === 'Data Export'
                    }
                    parentRecordException={masterRecordRef.current}
                    mapRecord={true}
                    includeAudit={basicInfoData?.includeAudit}
                    category={basicInfoData?.category}
                    handleDirty={handleDirty}
                    type={type}
                  />
                ) : (
                  <SearchImportMRGroup
                    setRecords={setRecords}
                    records={records}
                    setTempSelectedRows={setTempSelectedRows}
                    tempSelectedRows={tempSelectedRows}
                    handleClose={handleClose}
                    recordGroupType={{value: recordTypeRef.current}}
                    exportManagerRecordGroup={
                      exportManager || recordTypeRef.current === 'Data Export'
                    }
                    mapRecords={true}
                    includeAudit={basicInfoData?.includeAudit}
                    category={basicInfoData?.category}
                    handleDirty={handleDirty}
                    type={type}
                  />
                )}
              </DialogBox>

              <div className="d-flex justify-content-center mt-3 new-standard-textfields">
                <Button
                  variant="outlined"
                  onClick={() => {
                    handleBack();
                  }}
                  className={`reset-btn mr-1 ${classes.buttonRoot}`}
                >
                  Back
                </Button>
                {/* {basicInfoData?.isDraft === "N" && (
                  <Button
                    variant="outlined"
                    type="button"
                    className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                    onClick={() => {
                      saveRef.current = true;
                      handleDirty(false, "fixed");
                      handleSubmit(values);
                    }}
                  >
                    {"Save"}
                  </Button>
                )} */}
                {basicInfoData?.dmType &&
                basicInfoData?.dmType !== 'Customer Query' &&
                !exportManager ? (
                    <>
                      {/* {basicInfoData?.isDraft === "N" && ( */}
                      <Tooltip
                        title={
                          records.filter((item) => item.recordType === basicInfoData?.dmType)
                            ?.length === 0 ?
                            `Please add one ${basicInfoData?.dmType}` :
                            ''
                        }
                      >
                        <span>
                          <Button
                            variant="outlined"
                            type="button"
                            className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                            disabled={
                              !disableFunction(basicInfoData?.dmType) ||
                              (editExisting && !DataManagerAccess?.edit) || enabledSubmission
                            }
                            onClick={() => {
                              saveRef.current = true;
                              handleDirty(false, 'fixed');
                              handleSubmit(values);
                            }}
                          >
                            Save
                          </Button>
                        </span>
                      </Tooltip>
                      {/* )} */}
                      <Tooltip
                        title={
                          records.filter((item) => item.recordType === basicInfoData?.dmType)
                            ?.length === 0 ?
                          `Please add one ${basicInfoData?.dmType}` :
                            ''
                        }
                      >
                        <span>
                          <Button
                            variant="outlined"
                            onClick={() => {
                              handleSubmit(values);
                              saveRef.current = false;
                            }}
                            disabled={
                              !disableFunction(basicInfoData?.dmType) ||
                            (editExisting && !DataManagerAccess?.edit) || enabledSubmission
                            }
                            className={`search-btn ml-1 ${classes.buttonRoot}`}
                          >
                          Save & Next
                          </Button>
                        </span>
                      </Tooltip>
                    </>
                  ) : null}
                {basicInfoData?.dmType &&
                basicInfoData?.dmType === 'Customer Query' &&
                !exportManager ? (
                    <>
                      {/* {basicInfoData?.isDraft === "N" && ( */}
                      <Tooltip
                        title={
                          records.filter((item) => item.recordType === basicInfoData?.dmType)
                            ?.length === 0 ||
                          records.filter((item) => item.recordType === 'Data Export')?.length === 0 ?
                            `Please add one Customer Query and atleast one Data Export` :
                            ''
                        }
                      >
                        <span>
                          <Button
                            variant="outlined"
                            type="button"
                            className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                            disabled={
                              records.filter((item) => item.recordType === basicInfoData?.dmType)
                                ?.length === 0 ||
                              records.filter((item) => item.recordType === 'Data Export')
                                ?.length === 0 ?
                                `Please add one Customer Query and atleast one Data Export` :
                                '' || (editExisting && !DataManagerAccess?.edit) || enabledSubmission
                            }
                            onClick={() => {
                              saveRef.current = true;
                              handleDirty(false, 'fixed');
                              handleSubmit(values);
                            }}
                          >
                            Save
                          </Button>
                        </span>
                      </Tooltip>
                      {/* )} */}
                      <Tooltip
                        title={
                          records.filter((item) => item.recordType === basicInfoData?.dmType)
                            ?.length === 0 ||
                        records.filter((item) => item.recordType === 'Data Export')?.length === 0 ?
                          `Please add one Customer Query and atleast one Data Export` :
                            ''
                        }
                      >
                        <span>
                          <Button
                            variant="outlined"
                            onClick={() => {
                              handleSubmit(values);
                              saveRef.current = false;
                            }}
                            disabled={
                              records.filter((item) => item.recordType === basicInfoData?.dmType)
                                ?.length === 0 ||
                            records.filter((item) => item.recordType === 'Data Export')?.length ===
                              0 ||
                            (editExisting && !DataManagerAccess?.edit) || enabledSubmission
                            }
                            className={`search-btn ml-1 ${classes.buttonRoot}`}
                          >
                          Save & Next
                          </Button>
                        </span>
                      </Tooltip>
                    </>
                  ) : null}
                {basicInfoData?.dmType && exportManager ? (
                  <>
                    {/* {basicInfoData?.isDraft === "N" && ( */}
                    <Tooltip
                      title={
                        records.filter((item) => item.recordType === 'Data Export')?.length === 0 ?
                            `Please add at least one Data Export` :
                          ''
                      }
                    >
                      <span>
                        <Button
                          variant="outlined"
                          type="button"
                          className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                          disabled={
                            records.filter((item) => item.recordType === 'Data Export')
                              ?.length === 0 ||
                              (editExisting && !DataManagerAccess?.edit) || enabledSubmission
                          }
                          onClick={() => {
                            saveRef.current = true;
                            handleDirty(false, 'fixed');
                            handleSubmit(values);
                          }}
                        >
                          Save
                        </Button>
                      </span>
                    </Tooltip>
                    {/* )} */}
                    <Tooltip
                      title={
                        records.filter((item) => item.recordType === 'Data Export')?.length === 0 ?
                          `Please add at least one Data Export` :
                          ''
                      }
                    >
                      <span>
                        <Button
                          variant="outlined"
                          onClick={() => {
                            handleSubmit(values);
                            saveRef.current = false;
                          }}
                          disabled={
                            records.filter((item) => item.recordType === 'Data Export')?.length ===
                              0 ||
                            (editExisting && !DataManagerAccess?.edit) || enabledSubmission
                          }
                          className={`search-btn ml-1 ${classes.buttonRoot}`}
                        >
                          Save & Next
                        </Button>
                      </span>
                    </Tooltip>
                  </>
                ) : null}
              </div>
            </Form>
          );
        }}
      </Formik>
      {isBasicInfoLoading && <PageLoader />}
      {basicInfoErrorMsg && <ErrorSnackbar errorMsg={basicInfoErrorMsg} />}
      {basicInfoSuccessMsg && <SuccessSnackbar successMsg={basicInfoSuccessMsg} />}
    </>
  );
};

export default MapRecordGroup;
